export default __webpack_public_path__ + "static/media/hht2_home_img_EP5.16913a72.png";